import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroModule } from 'src/app/shared/components/hero/hero.module';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { AlertModule } from '../../shared/components/alert/alert.module';
import { ProductChoiceModule } from 'src/app/shared/components/product-choice/product-choice.module';

import { SelfAttendanceCancellationComponent } from './cancellation.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { MobileDropdownModule } from '../../shared/components/mobile-dropdown/mobile-dropdown.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


@NgModule({
  imports: [
    CommonModule,
    
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    AlertModule,
    ProductChoiceModule,
    FormsModule,
    ReactiveFormsModule,
    HeroModule,
    NgxMaskDirective,
    MatIconModule,
    MobileDropdownModule
  ],
  exports: [
    SelfAttendanceCancellationComponent
  ],
  providers: [
    provideNgxMask()
  ],
  declarations: [
    SelfAttendanceCancellationComponent
  ]
})

export class SelfAttendanceCancellationModule { }
